import Phrase from '../../libs/translationsUtils/phrase'
import { Component } from 'preact'
import cookies from 'js-cookie'
import classnames from 'classnames'
import _ from 'underscore'
import { ModulesContext, subscribe } from '../../utils/globals'
import { GeneralDbConfig } from '../../services/generalConfig'

// For more info:
// https://insidedhq.atlassian.net/wiki/spaces/IM/pages/6422598/Cookie+permission+dialog+setup

const PRIVACY_LEVEL_ALL = 3
const PRIVACY_LEVEL_NONE = 1

const levels = [1, 2, 3] as const

type Level = typeof levels[number]

interface Props {
  level: Level
  termsConditions: string
  cookieConfig: GeneralDbConfig['config']['params']['mapExternalPrivacyCookie']
}

interface State {
  isSettingsOpen: boolean
  isCookieSet: boolean
  selectedValue: Level
}

class CookieBanner extends Component<Props, State> {
  setCookie (level: Level) {
    const config = this.props.cookieConfig
    const levels: Record<Level, string> = _.invert(config.mapping)
    let value = levels[level]
    if (config.type === 'json') {
      const cookie = cookies.get(this.cookieName())
      let parsedCookie: Record<string, string> = {}
      try {
        parsedCookie = JSON.parse(cookie)
      } catch (e) { }
      parsedCookie[config.field || ''] = value
      value = JSON.stringify(parsedCookie)
    }
    cookies.set(this.cookieName(), value, { expires: config.expires || 365 })
    this.setState({ isSettingsOpen: false, isCookieSet: true })
  }

  getCookieValue (): Level {
    const cookie = cookies.get(this.cookieName())
    const config = this.props.cookieConfig
    if (config.type !== 'json') return config.mapping[cookie] || PRIVACY_LEVEL_NONE

    let parsedCookie: Record<string, Level> = {}
    try {
      parsedCookie = JSON.parse(cookie)
    } catch (e) { }

    return config.mapping[parsedCookie[config.field || '']] || PRIVACY_LEVEL_NONE
  }

  constructor (props: Props) {
    super(props)
    this.state = {
      isSettingsOpen: false,
      selectedValue: this.getCookieValue(),
      isCookieSet: typeof cookies.get(this.cookieName()) !== 'undefined'
    }
  }

  componentDidMount () {
    subscribe('edit_cookie_settings', () => this.setState({ isSettingsOpen: true }))
  }

  cookieName () {
    return this.props.cookieConfig.name || 'cookiePrivacyLevel'
  }

  render (props: Props) {
    if (typeof window === 'undefined') return null

    return (
      <ModulesContext.Consumer>
        {modules => {
          if (!modules.includes('cookiebar') || props.cookieConfig.use_external_modal) return null

          return (
            <div>
              <div
                class={classnames('cookiebar', 'js-cookiebar', {
                  'is-hidden': !this.state.isSettingsOpen && this.state.isCookieSet
                })}
                style={this.state.isSettingsOpen ? 'top: 0' : ''}
              >

                <div class={classnames('container', 'js-cookiebar-short', {
                  'is-hidden': this.state.isSettingsOpen || this.state.isCookieSet
                })}
                >
                  <h3><Phrase m='Forum' p='cookiepolicy.title' /></h3>
                  <p><Phrase printRaw m='Forum' p='cookiepolicy.content' count={{ link: props.termsConditions }} /></p>
                  <div>
                    <button class='btn js-cookie-accept' onClick={() => this.setCookie(PRIVACY_LEVEL_ALL)}>
                      <Phrase p='cookiepolicy.button' />
                    </button>
                    &nbsp;
                    <button class='btn btn-secondary js-cookie-deny' onClick={() => this.setCookie(PRIVACY_LEVEL_NONE)}>
                      <Phrase p='cookiepolicy.button.deny' />
                    </button>
                  </div>
                  <a class='cookiebar--info js-cookie-info' onClick={() => this.setState({ isSettingsOpen: true })}><Phrase p='cookiepolicy.link' /></a>
                </div>

                <div class={classnames('js-cookiemodal', 'cookiemodal-wrapper', {
                  'is-hidden': !this.state.isSettingsOpen
                })}
                >
                  <div class='js-cookiemodal-close cookiemodal-close' onClick={() => this.setState({ isSettingsOpen: false })}>×</div>
                  <h3><Phrase p='cookiepolicy.modal.title' /></h3>
                  <br />
                  <p><Phrase printRaw p='cookiepolicy.modal.content' count={{ link: props.termsConditions }} /></p>
                  <br />

                  {levels.map(level => {
                    return (
                      <div key={level}>
                        <div class='fancyselect'>
                          <input class='js-level-radio' id={`privacy_level_${level}`} name='privacyLevel' value={level} type='radio' checked={level === this.state.selectedValue} autocomplete='off' onClick={() => this.setState({ selectedValue: level })} />
                          <label for={`privacy_level_${level}`}>
                            <Phrase printRaw p={`cookiepolicy.modal.level${level}`} />
                          </label>
                        </div>
                        <br />
                      </div>
                    )
                  })}
                  <div>
                    <button class='btn js-select-level' onClick={() => this.setCookie(this.state.selectedValue)}>
                      <Phrase p='cookiepolicy.button' />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )
        }}
      </ModulesContext.Consumer>
    )
  }
}

export default CookieBanner
